import { render } from "./AiChartBlock.vue?vue&type=template&id=028391e9&scoped=true"
import script from "./AiChartBlock.vue?vue&type=script&lang=js"
export * from "./AiChartBlock.vue?vue&type=script&lang=js"

import "./AiChartBlock.vue?vue&type=style&index=0&id=028391e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028391e9"]])

export default __exports__